import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import { Link } from 'react-router-dom';
import 'highlight.js/styles/github.css';

type Props = { text: string };

export const BotResponse = ({ text }: Props) => {
  const [visible, setVisible] = useState('');

  useEffect(() => {
    setVisible('');
    let i = 1;
    const interval = setInterval(() => {
      setVisible(text.slice(0, i));
      i += 1;
      if (i > text.length) clearInterval(interval);
    }, 10);
    return () => clearInterval(interval);
  }, [text]);

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[[rehypeHighlight, { ignoreMissing: true }]]}
      components={{
        a: ({ href, ...props }) => {
          if (href && href.startsWith('https://triplex-design.ru/ru')) {
            // Убираем домен, оставляем локальный путь
            const localPath = href.replace('https://triplex-design.ru', '');
            return <Link to={localPath} {...props} />;
          }
          // Внешние ссылки — как обычные <a>
          return <a href={href} target="_blank" rel="noopener noreferrer" {...props} />;
        },
        p: (props) => <p style={{ marginBottom: 8 }} {...props} />,
        code: ({ inline, className = '', children, ...props }) =>
          !inline ? (
            <pre>
              <code className={className} {...props}>{children}</code>
            </pre>
          ) : (
            <code className={className} {...props}>{children}</code>
          ),
      }}
    >
      {visible}
    </ReactMarkdown>
  );
};